import { push } from "svelte-spa-router";
import { Writable, writable } from "svelte/store";
import { service } from "./services";
import { RegisterStartupCallback } from "./startup";
import type { ApiResultOfLoginDTO, PublicUserDTO, User, LoginWalletDTO } from "./walletapi";


export const me: Writable<PublicUserDTO | undefined> = writable(undefined);

export const TOKEN_STORAGE_KEY = "token"

export async function Login(loginData: LoginWalletDTO): Promise<ApiResultOfLoginDTO>
{
    const response = await service.walletapi.loginWallet(loginData);

    if (!response?.Success || !response.Data)
    {
        return response;
    }

    let user = response.Data.User;

    SetToken(response.Data.Token!);
    me.set(user);

    return response;
}


export async function Logout (){
    DeleteToken();
    me.set(undefined);
}

let cachedToken: string | null = null;

export function GetToken()
{
    let token = sessionStorage.getItem(TOKEN_STORAGE_KEY);
    cachedToken = token;
    return token;
}

export function GetCachedToken()
{
    return cachedToken!;
}

export function SetToken(newToken: string)
{
    sessionStorage.setItem(TOKEN_STORAGE_KEY, newToken);
    cachedToken = newToken;
}

export function DeleteToken()
{
    sessionStorage.removeItem(TOKEN_STORAGE_KEY);
    cachedToken = null;
}

export async function RefreshMe()
{
    const token = await GetToken();
    if (!token)
    {
        return;
    }

    const response = await service.walletapi.me({
        Token: token
    });

    if (!response?.Success)
    {
        return undefined;
    }

    let user = response.Data!.User;

    SetToken(response.Data!.Token!);
    me.set(user);

    return user;
}

RegisterStartupCallback("RefreshMe", async () => {
    await RefreshMe()
});

export function RedirectAfterLogin(me: PublicUserDTO | undefined)
{
    if (!me)
    {
        return false;
    }

    if (me.Role == "Owner") {
        push("/AdminList");
        return true;
    }

    if (me.Role == "Admin")
    {
        push("/PlayerList");
        return true;
    }
    if (me.Role == "Cashier")
    {
        push("/PlayerList");
        return true;
    }
        

}

export function CanViewPin(user: User): boolean
{
    if (!user) return false;

    return user.Role == "Owner" || user.Role == "Admin";
}


// export const emptyUser: Readonly<AddUserDTO> = {
//     Role: UserRole.Admin
//     FirstName: "",
//     LastName: undefined,
//     Email: undefined,
//     PhoneNumber: undefined,
//     Enabled: true,
// };
